import Joi from "joi-browser";
import React from "react";
import Form from "../../comman/form";

class PhoneCallApplicantPopup extends Form {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      errors: {},
    };
  }

  schema = {
    callDate: Joi.string().required().label("Call Date"),
    callTime: Joi.string().required().label("Call Time"),
    duration: Joi.string().required().label("Call Duration"),
  };

  doSubmit = () => {
    const { data } = this.state;
    if (data["phoneId"] !== null && data["phoneId"] !== undefined) {
      this.props.handleEditComment(data);
    } else {
      this.props.handleSubmit(data);
    }
  };

  componentWillReceiveProps(nextProps) {
    const { selectedItem } = nextProps;
    if (selectedItem) {
      const newItem = { ...selectedItem };
      const callDate = newItem["callDate"];
      const dur = newItem["duration"];
      if (callDate)
        newItem["callDate"] = callDate.split("T")[0];
      if (dur > 0) newItem["duration"] = dur?.toString();
      this.setState({ data: newItem });
    } else {
      this.setState({ data: {}, errors: {} });
    }
  }

  render() {
    const isEditMode = this.state.data["phoneId"] !== null && this.state.data["phoneId"] !== undefined;

    return (
      <>
        <style>{`
          .rt-add-form-container {
            max-width: 100% !important;
            margin: 0 0 12px 0 !important;
            background: #ffffff;
            border: 1px solid #e2e8f0;
            border-radius: 14px;
            padding: 20px 24px;
            box-shadow: 0 10px 15px -3px rgba(0,0,0,0.03), 0 4px 6px -2px rgba(0,0,0,0.03);
          }
          .rt-add-form-header {
            margin-bottom: 16px;
            border-bottom: 1px solid #f1f5f9;
            padding-bottom: 12px;
          }
          .rt-add-form-header h2 {
            font-size: 16px !important;
            font-weight: 700 !important;
            color: #0f172a !important;
            margin: 0 0 4px 0 !important;
            display: flex;
            align-items: center;
            gap: 8px;
          }
          .rt-add-form-header p {
            font-size: 12.5px !important;
            color: #64748b !important;
            margin: 0 !important;
            line-height: 1.4;
          }
          .rt-add-form-container .form-control {
            border: 1.5px solid #cbd5e1 !important;
            border-radius: 9px !important;
            font-size: 13.5px !important;
            padding: 10px 14px !important;
            height: auto !important;
            color: #1e293b !important;
            background-color: #ffffff !important;
            box-shadow: 0 1px 2px 0 rgba(0,0,0,0.02) !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          }
          .rt-add-form-container .form-control:focus {
            border-color: #2563eb !important;
            box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1) !important;
            background-color: #fafbff !important;
          }
          .rt-add-form-container .wf-input-wrap .form-control,
          .rt-add-form-container .wf-input-wrap input[type="date"],
          .rt-add-form-container .wf-input-wrap input[type="time"],
          .rt-add-form-container .wf-input-wrap input[type="number"],
          .rt-add-form-container .wf-input-wrap textarea,
          .rt-add-form-container .wf-input-withicon {
            padding: 10px 14px 10px 38px !important;
            padding-inline-start: 38px !important;
          }
          .rt-add-form-container .form-control-label,
          .rt-add-form-container label {
            font-size: 12.5px !important;
            font-weight: 700 !important;
            color: #475569 !important;
            margin-bottom: 6px !important;
            text-transform: none !important;
            letter-spacing: normal !important;
          }
          .rt-add-form-container .form-group {
            margin-bottom: 24px !important;
          }
          .rt-add-form-container .wf-input-wrap:has(textarea) .wf-input-icon {
            top: 14px !important;
            transform: none !important;
          }
          .rt-add-form-container .form-group.required .form-control-label::after,
          .rt-add-form-container .form-group.required label::after {
            content: " *" !important;
            color: #ef4444 !important;
            font-weight: bold !important;
          }
          .rt-add-form-container textarea.form-control {
            min-height: 100px !important;
            resize: vertical !important;
          }
          .rt-add-form-container .btn-save-form {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 8px !important;
            background: #2563eb !important;
            color: #ffffff !important;
            border: 1px solid #2563eb !important;
            padding: 10px 24px !important;
            border-radius: 9px !important;
            font-size: 13.5px !important;
            font-weight: 600 !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            outline: none !important;
            box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.15) !important;
          }
          .rt-add-form-container .btn-save-form:hover {
            background: #1d4ed8 !important;
            border-color: #1d4ed8 !important;
            transform: translateY(-1.5px) !important;
            box-shadow: 0 6px 12px -1px rgba(37, 99, 235, 0.25) !important;
          }
          .rt-add-form-container .btn-save-form:active {
            transform: translateY(0) !important;
          }
          .rt-add-form-container .btn-cancel-form {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 8px !important;
            background: #ffffff !important;
            color: #475569 !important;
            border: 1px solid #cbd5e1 !important;
            padding: 10px 24px !important;
            border-radius: 9px !important;
            font-size: 13.5px !important;
            font-weight: 600 !important;
            cursor: pointer !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            outline: none !important;
          }
          .rt-add-form-container .btn-cancel-form:hover {
            background: #f8fafc !important;
            color: #0f172a !important;
            border-color: #94a3b8 !important;
            transform: translateY(-1.5px) !important;
          }
          .rt-add-form-container .btn-cancel-form:active {
            transform: translateY(0) !important;
          }
          .rt-add-form-container .btn-save-form:disabled,
          .rt-add-form-container .btn-cancel-form:disabled {
            opacity: 0.65 !important;
            cursor: not-allowed !important;
            pointer-events: none !important;
            transform: none !important;
            box-shadow: none !important;
          }
          .rt-add-form-container .text-danger,
          .rt-add-form-container .alert-danger {
            font-size: 11.5px !important;
            color: #ef4444 !important;
            margin-top: 5px !important;
            font-weight: 500 !important;
            background: none !important;
            border: none !important;
            padding: 0 !important;
            display: block !important;
          }
        `}</style>
        <div className="rt-add-form-container">
          <div className="rt-add-form-header">
            <h2>
              <i className={`fa ${isEditMode ? "fa-pencil-square-o" : "fa-phone"}`} aria-hidden="true"></i>
              {isEditMode ? "Edit Phone Call Note" : "Log Phone Call"}
            </h2>
            <p>
              {isEditMode
                ? "Update the details for this phone call record."
                : "Record the details of a phone call with the applicant."}
            </p>
          </div>
          <div className="row">
            <div className="col-md-4 form-group">
              {this.renderInput("callDate", "Date", "date", "fa-calendar")}
            </div>
            <div className="col-md-4 form-group">
              {this.renderInput("callTime", "Time", "time", "fa-clock-o")}
            </div>
            <div className="col-md-4">
              {this.renderInput("duration", "Duration (Minutes)", "number", "fa-hourglass-half")}
            </div>
            <div className="col-md-12 form-group">
              {this.renderTextArea("comments", "Notes", "fa-pencil-square-o")}
            </div>
            <div className="col-md-12 text-center" style={{ marginTop: "24px", display: "flex", gap: "12px", justifyContent: "center" }}>
              <button
                className="btn-cancel-form"
                type="button"
                onClick={() => this.props.handleCancel()}
                disabled={this.props.isLoading}
              >
                <i className="fa fa-arrow-left" aria-hidden="true"></i> Back to Notes
              </button>
              <button
                className="btn-save-form"
                disabled={this.props.isLoading || this.validate()}
                onClick={this.handleSubmit}
              >
                {this.props.isLoading ? (
                  <>
                    <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                    {isEditMode ? "Updating..." : "Saving..."}
                  </>
                ) : (
                  <>
                    <i className="fa fa-save" aria-hidden="true"></i>
                    {isEditMode ? "Update Note" : "Save Note"}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default PhoneCallApplicantPopup;
